export default __webpack_public_path__ + "static/media/srl.d2f13cb9.png";